import Link from '@pray/shared/components/ui/Link/Link';
import { SOCIAL_LINKS, PRAY_EXTERNAL_LINKS } from '@pray/shared/constants';
import Facebook from '@pray/shared/icons/social/facebook';
import Instagram from '@pray/shared/icons/social/instagram';
import LinkedIn from '@pray/shared/icons/social/linkedin';
import TikTok from '@pray/shared/icons/social/tiktok';
import X from '@pray/shared/icons/social/X';
import YouTube from '@pray/shared/icons/social/youtube';

import useAppRoutes from 'hooks/useAppRoutes';

import { PRODUCT_LABELS, Products } from '../../types/products';
import PrayStudioLogo from '../icons/PrayStudioLogo';

import styles from './Footer.module.scss';

const Footer = ({ className = '' }) => {
  const appRoutes = useAppRoutes();
  const footerClasses = `${styles.footer} ${className}`.trim();

  const products = [
    { name: PRODUCT_LABELS[Products.SOCIAL_CLIPS], href: appRoutes.socialClips() },
    { name: PRODUCT_LABELS[Products.AI_TRANSLATIONS], href: appRoutes.translations() },
    { name: PRODUCT_LABELS[Products.MINISTRY_INSIGHTS], href: appRoutes.ministryInsights() },
    { name: PRODUCT_LABELS[Products.CRM], href: appRoutes.crm() },
    { name: PRODUCT_LABELS[Products.WORKFLOW_AI], href: appRoutes.workflowAi() },
    { name: PRODUCT_LABELS[Products.AI_AUDIO_BOOKS], href: appRoutes.audioBooks() },
  ];

  return (
    <footer className={footerClasses}>
      <div className={styles.viewport}>
        <div className={styles.columns}>
          <div className={styles.links}>
            <div>
              <PrayStudioLogo />
            </div>
          </div>

          <div className={styles.links}>
            <p>PRODUCTS</p>
            {products.map((product) => (
              <Link to={product.href}>{product.name}</Link>
            ))}
          </div>

          {/* <div className={styles.links}>
            <p>SOLUTIONS</p>
            <Link href={appRoutes.solutions.expandYourReach}>Expand your Reach</Link>
            <Link href={appRoutes.solutions.buildAndGrowYourNewsletter}>Build & Grow Your Newsletter</Link>
            <Link href={appRoutes.solutions.getNewDonors}>Get New Donors</Link>
            <Link href={appRoutes.solutions.buildDigitalMinistries}>Build Digital Ministries</Link>
          </div> */}

          <div className={styles.links}>
            <p>SOCIALS</p>
            <a target="_blank" href={SOCIAL_LINKS.YOUTUBE} rel="noreferrer">
              <YouTube className={styles.icon} /> YouTube
            </a>
            <a target="_blank" href={SOCIAL_LINKS.X} rel="noreferrer">
              <X className={styles.icon} /> X (Ex Twitter)
            </a>
            <a target="_blank" href={SOCIAL_LINKS.FACEBOOK} rel="noreferrer">
              <Facebook className={styles.icon} /> Facebook
            </a>
            <a target="_blank" href={SOCIAL_LINKS.LINKED_IN} rel="noreferrer">
              <LinkedIn className={styles.icon} /> LinkedIn
            </a>
            <a target="_blank" href={SOCIAL_LINKS.INSTAGRAM} rel="noreferrer">
              <Instagram className={styles.icon} /> Instagram
            </a>
            <a target="_blank" href={SOCIAL_LINKS.TIKTOK} rel="noreferrer">
              <TikTok className={styles.icon} /> TikTok
            </a>
          </div>
        </div>

        <div className={styles.bottom}>
          <div className={styles.copyright}>
            <p>&copy; {new Date().getFullYear()} Pray.com Inc. All rights reserved</p>
          </div>

          <div className={styles.legalLinks}>
            <a href={PRAY_EXTERNAL_LINKS.TERMS_OF_SERVICE}>Terms of Service</a>
            <a href={PRAY_EXTERNAL_LINKS.PRIVACY_POLICY}>Privacy Policy</a>
            <a href={PRAY_EXTERNAL_LINKS.COOKIE_POLICY}>Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
